import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import App from './App.tsx';
import {
  ApplicationViewStateProvider,
  BillingProvider,
  CookiesPermissionProvider,
  DomainSelectionProvider,
  MerchantSessionProvider,
  OwnershipClaimProvider,
  StripeKeyProvider,
} from './context';
import { AnalyticsGlobalListener } from './services/analytics/analyticsGlobalListener.tsx';
import { Theme } from './Theme.tsx';
import { i18n } from './utils/i18n';

const socialLoginGoogleClientId = import.meta.env
  .VITE_SOCIAL_LOGIN_GOOGLE_CLIENT_ID;

const stripePublishableKeys = {
  us: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_US,
  row: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_ROW,
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={socialLoginGoogleClientId}>
      <I18nextProvider i18n={i18n}>
        <AnalyticsGlobalListener />
        <Theme>
          <ApplicationViewStateProvider>
            <CookiesPermissionProvider>
              <MerchantSessionProvider>
                <BillingProvider>
                  <DomainSelectionProvider>
                    <StripeKeyProvider publishableKeys={stripePublishableKeys}>
                      <OwnershipClaimProvider>
                        <App />
                      </OwnershipClaimProvider>
                    </StripeKeyProvider>
                  </DomainSelectionProvider>
                </BillingProvider>
              </MerchantSessionProvider>
            </CookiesPermissionProvider>
          </ApplicationViewStateProvider>
        </Theme>
      </I18nextProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
